module.exports = __webpack_public_path__ + "7b3fec961bd9b8a82abd20a2648d2179.svg";